export default __webpack_public_path__ + "static/media/suitcase-icon.a52b979e.svg";